import React, { createContext, useContext, useState } from 'react'

export type GlobalNavContextType = {
  globalNavOpen: boolean
  setGlobalNavOpen: (open: boolean) => void
  globalNavHeight: number | undefined
  setGlobalNavHeight: (height: number) => void
}

export const GlobalNavContext = createContext<GlobalNavContextType | undefined>(
  undefined
)

export const GlobalNavContextProvider = ({
  children
}: React.PropsWithChildren<{}>) => {
  const [globalNavOpen, setGlobalNavOpen] = useState<boolean>(true)
  const [globalNavHeight, setGlobalNavHeight] = useState<number>()
  return (
    <GlobalNavContext.Provider
      value={{
        globalNavOpen,
        setGlobalNavOpen,
        globalNavHeight,
        setGlobalNavHeight
      }}
    >
      {children}
    </GlobalNavContext.Provider>
  )
}

export const useGlobalNav = () => {
  const context = useContext(GlobalNavContext)
  if (!context) {
    throw new Error(
      'useGlobalNav must be used within a GlobalNavContextProvider'
    )
  }

  return context
}
